"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _interopRequireWildcard = require("@babel/runtime/helpers/interopRequireWildcard");

exports.__esModule = true;
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _IconButton = require("./IconButton");

var _Icon = _interopRequireDefault(require("../Icon/Icon"));

var IconToggleButton = function IconToggleButton(_ref) {
  var icon = _ref.icon,
      toggledIcon = _ref.toggledIcon,
      onClick = _ref.onClick;

  var _useState = (0, _react.useState)(false),
      isToggled = _useState[0],
      setIsToggled = _useState[1];

  var handleToggle = function handleToggle() {
    setIsToggled(!isToggled);
    onClick();
  };

  var getIconName = function getIconName() {
    return isToggled ? toggledIcon : icon;
  };

  return _react["default"].createElement(_IconButton.CircleButton, {
    onClick: handleToggle,
    size: 48
  }, _react["default"].createElement(_Icon["default"], {
    name: getIconName()
  }));
};

IconToggleButton.propTypes = {
  onClick: _propTypes["default"].func.isRequired,
  icon: _propTypes["default"].string.isRequired,
  toggledIcon: _propTypes["default"].string.isRequired
};
var _default = IconToggleButton;
exports["default"] = _default;